import { createIcon } from './icon-utils';

export const HorizontalDotsIcon = createIcon({
  fillRule: 'evenodd',
  path: 'M9 12.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm10 0a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zM12.5 14a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z',
});
